export function validateStudyForm (data) {
    let errors = {};    
    if (!data.title || data.title == '' || data.title == ' ')
        errors.title = 'Title is required';

    if (!data.parent_article || data.parent_article == '' || data.parent_article == ' ')
        errors.parent_article = 'Parent article is required';
    
    if (!data.parent_author || data.parent_author == '' || data.parent_author == ' ')
        errors.parent_author = 'Parent author is required';
    
    if (!data.authors || data.authors == '' || data.authors == ' ') 
        errors.authors = 'Authors are required';
    
    if (!data.publisher || data.publisher == '' || data.publisher == ' ')
        errors.publisher = 'Publisher is required';
    
    if (!data.year || data.year == '' || data.year == ' ')
        errors.year = 'Year is required';
    
    if (!data.pageFrom || data.pageFrom == 0 || data.pageFrom == null)
        errors.pageFrom = 'Page From is required';
    
    if (!data.pageTo || data.pageTo == 0 || data.pageTo == null)
        errors.pageTo = 'Page To is required';
    
    if (!data.isbn || data.isbn == '' || data.isbn == ' ')
        errors.isbn = 'ISBN is required';
    
    if (!data.city || data.city == '' || data.city == ' ')
        errors.city = 'City is required';
    
    if (Object.keys(errors).length > 0) {
        return errors;
    } else {
        return true;
    }
}